
import { defineComponent, reactive, ref } from 'vue'
import { useReflectiveInjector, Type } from '@tanbo/vue-di-plugin'
import KantuFooter from '@/components/footer/kantuFooter.vue'
import Tabs from '@/components/tabs/index.vue'
import { ConfigService } from '@/services/config.service'
import { isInFrame, sendMessageToParent } from '@/utils/frame'
import PhoneLogin from './_components/phone-login.vue'
import LogoffHeader from './_components/header.vue'
import OfficialLogoff from './_components/official-logoff.vue'
import Logoff from './logoff.vue'

export default defineComponent({
  name: 'LogoffVerification',
  components: {
    KantuFooter,
    Tabs,
    PhoneLogin,
    LogoffHeader,
    OfficialLogoff,
    Logoff
  },
  setup() {
    const injector = useReflectiveInjector()
    const config = injector.get(ConfigService as Type<ConfigService>)

    const viewModel = reactive({
      closeToken: '',
      logo: config.getLogo,
      title: config.getTitle,
      tabIdx: 0, // tab下标
      tabs: ['微信登录', '手机登录']
    })

    const isShowLogoffWrap = ref(false)

    /**
     * @description 切换tab
     */
    function toggleTab(idx: number) {
      if (viewModel.tabIdx === idx) {
        return
      }

      viewModel.tabIdx = idx
    }

    function clickClose() {
      if (isInFrame()) {
        sendMessageToParent({
          type: 'close',
        })
      }
      window.close()
    }

    function verifySuccess(closeToken: string) {
      viewModel.closeToken = closeToken
      isShowLogoffWrap.value = true
    }

    return {
      isShowLogoffWrap,
      viewModel,
      toggleTab,
      clickClose,
      verifySuccess,
    }
  }
})
